export const meditationCategories = [
  //"ANY_MEDITATION",
  // "PRAYER_MEDITATION",
  // "CLEANING_MEDITATION",
  // "GUIDANCE_MEDITATION",
  "PRAYER",
  "CLEANING",
  "MEDITATION",
];
